import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';

export const userRelationGroup = {
    userRelationGroupHandler
};

function userRelationGroupHandler(data) {

    return dispatch => {
        dispatch(request());
        relationGroupsService.userRelationGroupHandler(data)
            .then(
                relationGroup => {
                    dispatch(success(relationGroup));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: relationGroupsConstants.REQUEST_USER_RELATION_GROUP } }
    function success(relationGroup) { return { type: relationGroupsConstants.RECEIVE_USER_RELATION_GROUP, relationGroup } }
    function failure(error) { return { type: relationGroupsConstants.USER_RELATION_GROUP_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/userRelationGroup.action.js